﻿import config from "../config"
const baseUrl = config.base_url + "sdd_warning_type_item/"
export default {
    list: {
        url:  baseUrl + "list/{type}",
        type: "get",
    },
    page: {
        url:  baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    remove:{
        url:  baseUrl + "delete",
        type: "get",
    },
    save:{
        url:  baseUrl + "save",
        type: "post",
    },
    warningTypeList:{
        url:  baseUrl + "warningTypeList",
        type: "get",
    },
}
